import { useQuery } from '@tanstack/react-query'
import { api } from '@astro/api'

/** GET /general-settings — site-wide contact/branding config. Changes rarely,
 * so one fetch is shared across pages for the session. Same queryKey as the
 * apps' local useGeneralSettings hooks, so the cache entry is shared. */
export function useGeneralSettings() {
  const query = useQuery({
    queryKey: ['general-settings'],
    queryFn: () => api.generalSettings.get(),
    staleTime: 10 * 60 * 1000,
    select: (res) => res?.data ?? {},
  })
  return {
    settings: query.data ?? {},
    isPending: query.isPending,
    isError: query.isError,
  }
}
